import Vue from "vue";

const LocalStorageService = (function() {
  var _service;
  function _provision() {
    if (!_service) {
      _service = this;

      Vue.prototype.$localStorageService = _service;

      return _service;
    }
    return _service;
  }
  function _setToken(tokenObj) {
    localStorage.setItem("access_token", tokenObj.access_token);
    localStorage.setItem("refresh_token", tokenObj.refresh_token);
  }
  function _getAccessToken() {
    return localStorage.getItem("access_token");
  }
  function _getRefreshToken() {
    return localStorage.getItem("refresh_token");
  }
  function _clearToken() {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
  }
  function _setItem(key, value) {
    localStorage.setItem(key, value);
  }
  function _getItem(key) {
    return localStorage.getItem(key);
  }
  function _removeItem(key) {
      localStorage.removeItem(key);
  }
  return {
    provision : _provision,
    setToken: _setToken,
    getAccessToken: _getAccessToken,
    getRefreshToken: _getRefreshToken,
    clearToken: _clearToken,
    getItem: _getItem,
    setItem: _setItem,
    removeItem: _removeItem
  };
})();
export default LocalStorageService;
